import React from 'react';
import { BarChart3, MapPin, Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-950 border-t border-slate-800 pt-16 pb-8" data-id="element-65">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-66">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-67">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-68">
            <div className="flex items-center gap-2 mb-6" data-id="element-69">
              <div className="w-8 h-8 rounded-lg bg-emerald-500 flex items-center justify-center" data-id="element-70">
                <BarChart3 className="text-white w-5 h-5" data-id="element-71" />
              </div>
              <span className="text-lg font-bold text-white tracking-tight" data-id="element-72">
                Butineurjeu
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6" data-id="element-73">
              The next generation of ad intelligence. Automate, optimize, and
              scale your campaigns with AI precision.
            </p>
            <div className="flex items-center gap-2 text-slate-500 text-sm" data-id="element-74">
              <MapPin className="w-4 h-4" data-id="element-75" />
              <span data-id="element-76">Warszawa, Poland</span>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-77">
            <h4 className="text-white font-semibold mb-6" data-id="element-78">Platform</h4>
            <ul className="space-y-4 text-sm text-slate-400" data-id="element-79">
              <li data-id="element-80">
                <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-81">
                  Features
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-83">
                  Pricing
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-85">
                  Case Studies
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-87">
                  API Documentation
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-88">
            <h4 className="text-white font-semibold mb-6" data-id="element-89">Company</h4>
            <ul className="space-y-4 text-sm text-slate-400" data-id="element-90">
              <li data-id="element-91">
                <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-92">
                  About Us
                </a>
              </li>
              <li data-id="element-93">
                <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-94">
                  Careers
                </a>
              </li>
              <li data-id="element-95">
                <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-96">
                  Blog
                </a>
              </li>
              <li data-id="element-97">
                <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-98">
                  Legal
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-99">
            <h4 className="text-white font-semibold mb-6" data-id="element-100">Contact</h4>
            <ul className="space-y-4 text-sm text-slate-400" data-id="element-101">
              <li className="flex items-center gap-2" data-id="element-102">
                <Mail className="w-4 h-4" data-id="element-103" />
                <a href="mailto:hello@butineurjeu.com" className="hover:text-emerald-400 transition-colors" data-id="element-104">
                  hello@butineurjeu.com
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-105">
                <Globe className="w-4 h-4" data-id="element-106" />
                <a href="#" className="hover:text-emerald-400 transition-colors" data-id="element-107">
                  www.butineurjeu.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-108">
          <p className="text-slate-500 text-sm" data-id="element-109">
            © 2026 Butineurjeu. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-slate-500" data-id="element-110">
            <a href="#" className="hover:text-white transition-colors" data-id="element-111">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-112">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-113">
              Cookie Settings
            </a>
          </div>
        </div>
      </div>
    </footer>;
}